<!-- Color Blindness Simulator card: the conditions and the picture in (left), the picture split original / simulated (right) -->
<div class="cb-card">
  <div class="cb-side">
    <span class="cb-title">Simulation</span>
    <div class="cb-types" role="radiogroup" aria-label="Color vision deficiency">
      <div class="cb-group" *ngFor="let g of GROUPS">
        <span class="cb-group-name">
          <span class="cb-group-dots" aria-hidden="true"><i *ngFor="let d of g.dots" [style.background]="d"></i></span>{{ g.name }}
        </span>
        <div class="cb-group-types">
          <button type="button" class="cb-type" *ngFor="let t of g.types" role="radio"
                  [class.on]="t.type === type" [attr.aria-checked]="t.type === type" (click)="pick( t.type )">{{ t.name }}</button>
        </div>
      </div>
    </div>
    <div class="cb-actions">
      <button type="button" class="cb-btn" (click)="openFile()"><app-icon name="upload" aria-hidden="true"></app-icon>Upload Image</button>
      <button type="button" class="cb-btn" (click)="download()" [disabled]="loading"><app-icon name="download" aria-hidden="true"></app-icon>Download PNG</button>
    </div>
    <input #file type="file" accept="image/*" class="cb-file" (change)="onFile( $event )" aria-label="Upload an image"/>
  </div>

  <div class="cb-stage" [class.drop]="dropHover" (dragover)="onDragOver( $event )" (dragleave)="dropHover = false" (drop)="onDrop( $event )"
       (pointerdown)="onPointerDown( $event )" (pointermove)="onPointerMove( $event )" (pointerup)="onPointerUp()" (pointercancel)="onPointerUp()">
    <canvas #original class="cb-canvas" role="img" aria-label="The original picture"></canvas>
    <canvas #simulated class="cb-canvas cb-sim" role="img" [attr.aria-label]="'The picture with ' + info.name"
            [style.clip-path]="'inset(0 0 0 ' + splitInStage + '%)'"></canvas>
    <div class="cb-divider" [style.left.%]="splitInStage" role="slider" tabindex="0" aria-label="Compare original and simulated"
         [attr.aria-valuenow]="split | number: '1.0-0'" aria-valuemin="0" aria-valuemax="100" (keydown)="onSplitKey( $event )">
      <span class="cb-handle" aria-hidden="true"><app-icon name="right-left"></app-icon></span>
    </div>
    <span class="cb-tag cb-tag-left">Original</span>
    <span class="cb-tag cb-tag-right">{{ info.name }}</span>
    <span class="cb-hint" *ngIf="!loading">Drop or paste an image here</span>
    <span class="cb-status" *ngIf="loading || error">{{ error || 'Opening the image' }}</span>
  </div>
</div>
